import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'Bold'
   */
  variant?: Variant<'primary' | 'dhlRed' | 'goGreen' | 'inherit'>
}>

export const H3 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="h3" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
